import React, { useState } from "react";

import { Button } from "reactstrap";
import PopupAlert from "./../common/popupAlert";
import { toast } from "react-toastify";
// import { getQuetion } from "../../services/vms";
import { savecovic } from "../../services/wms/grabconcept";

const FormCovid = ({ onCancel,list }) => {

  const [answer1, setanswer1] = useState();
  const [answer2, setanswer2] = useState();
  const [answer3, setanswer3] = useState();
  const [answer4, setanswer4] = useState();
  const [answer5, setanswer5] = useState();
  const [answer6, setanswer6] = useState();
  const [answer7, setanswer7] = useState();
  const [answer8, setanswer8] = useState();
  const [messageErros, setmessageErros] = useState({
    askAlert: { enable: false, message: "" },
  });



  const handlePopupAlertClick = () => {
    setmessageErros({ askAlert: { enable: false, message: "" } });
  };
  const onRadioChange1 = (e) => {
    setanswer1(1);
  };
  const onRadioChange11 = (e) => {
    setanswer1(0);
  };
  const onRadioChange2 = (e) => {
    setanswer2(1);
  };
  const onRadioChange22 = (e) => {
    setanswer2(0);
  };
  const onRadioChange3 = (e) => {
    setanswer3(1);
  };
  const onRadioChange33 = (e) => {
    setanswer3(0);
  };
  const onRadioChange4 = (e) => {
    setanswer4(1);
  };
  const onRadioChange44 = (e) => {
    setanswer4(0);
  };
  const onRadioChange5 = (e) => {
    setanswer5(1);
  };
  const onRadioChange55 = (e) => {
    setanswer5(0);
  };
  const onRadioChange6 = (e) => {
    setanswer6(1);
  };
  const onRadioChange66 = (e) => {
    setanswer6(0);
  };
  const onRadioChange7 = (e) => {
    setanswer7(1);
  };
  const onRadioChange77 = (e) => {
    setanswer7(0);
  };
  const onRadioChange8 = (e) => {
    setanswer8(1);
  };
  const onRadioChange88 = (e) => {
    setanswer8(0);
  };
  const doSubmit = async () => {
    try {
      const doc = {
        IdentityID: list.identityId,
        ComID: list.cusid,
        FirstName: list.fname,
        LastName: list.lname, 
        Details: "|"+answer1+","+answer2+","+answer3+","+answer4+","+answer5+","+answer6+","+answer7+","+answer8+"|"

      };
      
     const { data: result } = await savecovic(doc);
       if (result.status === "success") {
        toast.success("บันทึกประเมิณ Covic-19 เรียบร้อยค่ะ");
       onCancel(false)

        } else {
          toast.error(result.message);
        }
    } catch (err) {
      onCancel();
      toast.error("Error Try Catch Covic-19");
    }
  };

  const handelsave = () => {
    if (answer1 === undefined) {

      setmessageErros({
        askAlert: {
          enable: true,
          message: "กรุณา ตอบประเมิณ ข้อที่1 ค่ะ",
        },
      });
      return;
    } else if (answer2 === undefined) {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "กรุณา ตอบประเมิณ ข้อที่2 ค่ะ",
        },
      });
      return;
    } else if (answer3 === undefined) {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "กรุณา ตอบประเมิณ ข้อที่3 ค่ะ",
        },
      });
      return;
    } else if (answer4 === undefined) {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "กรุณา ตอบประเมิณ ข้อที่4 ค่ะ",
        },
      });
      return;
    } else if (answer5 === undefined) {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "กรุณา ตอบประเมิณ ข้อที่5 ค่ะ",
        },
      });
      return;
    } else if (answer6 === undefined) {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "กรุณา ตอบประเมิณ ข้อที่6 ค่ะ",
        },
      });
      return;
    } else if (answer7 === undefined) {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "กรุณา ตอบประเมิณ ข้อที่7 ค่ะ",
        },
      });
      return;
    } else if (answer8 === undefined) {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "กรุณา ตอบประเมิณ ข้อที่8 ค่ะ",
        },
      });
      return;
    }else if ( list.fname=="") {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "กรุณาใส่ชื่อ-สกุล ผุ้ขับค่ะ",
        },
      });
      return;
    }else if (list.identityId =="") {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "กรุณาใส่เลขที่บัตรประชาชน ค่ะ",
        },
      });
      return;
    }
    //else if (list.cusid =="") {
    //   setmessageErros({
    //     askAlert: {
    //       enable: true,
    //       message: "กรุณาใส่เลือกชื่อลูกค้า ค่ะ",
    //     },
    //   });
    //   return;
    // }
    // setmessage("ท่านยืนยัน ที่ทำการบันทึกรายการใช่หรือไม่");
    // setaskConfirm(true);
    doSubmit();
  };
  return (
    <div className="w3-container  w3-text-black  w3-center">
      <div className="w3-clear" />

      <div className="panel-group w3-padding-24 w3-margin">
        <div className="panel panel-default">
          <PopupAlert
            isOpen={messageErros.askAlert.enable}
            onOk={handlePopupAlertClick}
            message={messageErros.askAlert.message}
          />
          <div
            id="txt_Menu"
            runat="server"
            className="panel-heading w3-xlarge w3-center"
          >
            <div className=" center w3-center">
              แบบประเมินความเสี่ยงของผู้ที่มาติดต่อบริษัท Double A
              ต่อการติดเชื้อ COVID-19
              <br />
              (Visitors risk survey for COVID-19 Virus )
            </div>
          </div>
          <div className="panel-body" style={{ width: "100%" }} />
          <div className="table-wrapper">
            <div className="table-title" style={{ height: 20 }}>
              <div className="row" style={{ height: 0 }}></div>
            </div>
            <table
              id="tb_ListPermit"
              runat="server"
              className="table table-striped table-hover"
            >
              <colgroup>
                <col width="80%" />
                <col width="70%" />
              </colgroup>
              <tbody>
                <tr />
              </tbody>
              <tbody>
                <tr data-status={1}>
                  <td style={{ textAlign: "left" }}>
                    1. ใน 14 วันที่ผ่านมา
                    ท่านเดินทางหรืออาศัยในพื้นที่ที่มีรายงานการระบาดต่อเนื่องของโรคติดเชื้อไวรัส
                    COVID-19 (In the past 14 days , Did you have been or lived
                    in the risky countries of COVID-19 ? ) *
                  </td>
                  <td className="col-3 text-center">
                    <fieldset id="group1" style={{}}>
                      <label id="lb1" className="containerradio">
                        ใช่ (Yes)
                        <input
                          type="radio"
                       
                          onChange={onRadioChange1}
                          name="group11"
                          id="RadioB1"
                          runat="server"
                          required
                        />
                        <span id="SRadioB1" className="checkmark" />
                      </label>
                      <label
                        className="containerradio"
                        style={{ marginLeft: 5 }}
                      >
                        ไม่ใช่ (No)
                        <input
                          type="radio"
                          name="group11"
                          id="RType2"
                          runat="server"
                          onChange={onRadioChange11}
                        />
                        <span className="checkmark" />
                      </label>
                    </fieldset>
                  </td>
                </tr>
                <tr data-status={2}>
                  <td style={{ textAlign: "left" }}>
                    2. ใน 14 วันล่วงหน้าจากนี้
                    ท่านมีแผนเดินทางหรืออาศัยในพื้นที่ที่มีรายงานการระบาดต่อเนื่องของโรคติดเชื้อไวรัส
                    COVID-19 (Next 14 Days , Did you have plan go to the risky
                    countries of COVID-19 ? ) *
                  </td>
                  <td className="col-3 text-center">
                    <fieldset id="group2" style={{}}>
                      <label id="lb2" className="containerradio">
                        ใช่ (Yes)
                        <input
                          type="radio"
                          onChange={onRadioChange2}
                          name="group2"
                          id="RadioB2"
                          runat="server"
                          required
                        />
                        <span id="SRadioB2" className="checkmark" />
                      </label>
                      <label
                        className="containerradio"
                        style={{ marginLeft: 5 }}
                      >
                        ไม่ใช่ (No)
                        <input
                          type="radio"
                          name="group2"
                          id="Radio2"
                          runat="server"
                          onChange={onRadioChange22}
                        />
                        <span className="checkmark" />
                      </label>
                    </fieldset>
                  </td>
                </tr>
                <tr data-status={3}>
                  <td style={{ textAlign: "left" }}>
                    3. ท่านเป็นผู้ประกอบอาชีพที่สัมผัสใกล้ชิดกับนักท่องเที่ยว
                    หรือผู้ที่เดินทางที่มาจากพืนที่ที่มีรายงานการระบาดต่อเนื่องของโรคติดเชื้อไวรัส
                    COVID-19 (Did your work have to contact directly with
                    tourists or people who traveled from the risky countries of
                    COVID19?) *
                  </td>
                  <td className="col-3 text-center">
                    <fieldset id="group3" style={{}}>
                      <label id="lb3" className="containerradio">
                        ใช่ (Yes)
                        <input
                          type="radio"
                          onChange={onRadioChange3}
                          name="group3"
                          id="RadioB3"
                          runat="server"
                          required
                        />
                        <span id="SRadioB3" className="checkmark" />
                      </label>
                      <label
                        className="containerradio"
                        style={{ marginLeft: 5 }}
                      >
                        ไม่ใช่ (No)
                        <input
                          type="radio"
                          name="group3"
                          id="Radio3"
                          runat="server"
                          onChange={onRadioChange33}
                        />
                        <span className="checkmark" />
                      </label>
                    </fieldset>
                  </td>
                </tr>
                <tr data-status={4}>
                  <td style={{ textAlign: "left" }}>
                    4.
                    มีประวัติใกล้ชิดหรือสัมผัสกับผู้ป่วยเข้าข่ายหรือยืนยันโรคติดเชื้อไวรัส
                    COVID-19 (Did you have a chance to face to face interaction
                    with people who infected the COVID19 Virus?) *
                  </td>
                  <td className="col-3 text-center">
                    <fieldset id="group4" style={{}}>
                      <label id="lb4" className="containerradio">
                        ใช่ (Yes)
                        <input
                          type="radio"
                          onChange={onRadioChange4}
                          name="group4"
                          id="RadioB4"
                          runat="server"
                          required
                        />
                        <span id="SRadioB4" className="checkmark" />
                      </label>
                      <label
                        className="containerradio"
                        style={{ marginLeft: 5 }}
                      >
                        ไม่ใช่ (No)
                        <input
                          type="radio"
                          name="group4"
                          id="Radio4"
                          runat="server"
                          onChange={onRadioChange44}
                        />
                        <span className="checkmark" />
                      </label>
                    </fieldset>
                  </td>
                </tr>
                <tr data-status={5}>
                  <td style={{ textAlign: "left" }}>
                    5.
                    มีผู้ที่อยู่อาศัยร่วมบ้านเดินทางกลับมาจากพื้นที่ที่มีรายงานการระบาดของโรคติดเชื้อไวรัส
                    COVID-19 (Did you live with people who traveled to the risky
                    countries of COVID19?) *
                  </td>
                  <td className="col-3 text-center">
                    <fieldset id="group5" style={{}}>
                      <label id="lb5" className="containerradio">
                        ใช่ (Yes)
                        <input
                          type="radio"
                          onChange={onRadioChange5}
                          name="group5"
                          id="RadioB5"
                          runat="server"
                          required
                        />
                        <span id="SRadioB5" className="checkmark" />
                      </label>
                      <label
                        className="containerradio"
                        style={{ marginLeft: 5 }}
                      >
                        ไม่ใช่ (No)
                        <input
                          type="radio"
                          name="group5"
                          id="Radio5"
                          runat="server"
                          onChange={onRadioChange55}
                        />
                        <span className="checkmark" />
                      </label>
                    </fieldset>
                  </td>
                </tr>
                <tr data-status={6}>
                  <td style={{ textAlign: "left" }}>
                    6. เป็นบุคลากรทางการแพทย์
                    หรือสาธารณสุขทีสัมผัสกับผู้ป่วยเข้าเกณฑ์สอบสวนโรคติดเชื้อไวรัส
                    COVID-19 (Are you medical staffs or public officers who
                    interact with people who infected COVID19?) *
                  </td>
                  <td className="col-3 text-center">
                    <fieldset id="group6" style={{}}>
                      <label id="lb6" className="containerradio">
                        ใช่ (Yes)
                        <input
                          type="radio"
                          onChange={onRadioChange6}
                          name="group6"
                          id="RadioB6"
                          runat="server"
                          required
                        />
                        <span id="SRadioB6" className="checkmark" />
                      </label>
                      <label
                        className="containerradio"
                        style={{ marginLeft: 5 }}
                      >
                        ไม่ใช่ (No)
                        <input
                          type="radio"
                          name="group6"
                          id="Radio6"
                          runat="server"
                          onChange={onRadioChange66}
                        />
                        <span className="checkmark" />
                      </label>
                    </fieldset>
                  </td>
                </tr>
                <tr data-status={6}>
                  <td style={{ textAlign: "left" }}>
                    7. ใน 14 วันข้างหน้า
                    (นับจากวันที่ท่านได้ทำเรื่องขออนุมัติเข้าโรงงานในระบบ)
                    ท่านรับรองว่าจะไม่ปฏิบัติตนเพื่อเข้าข่ายกลุ่มเสี่ยงโรคติดเชื้อไวรัส
                    COVID-19 ทั้งการใกล้ชิด และสัมผัส กับผู้ป่วยโรคติดเชื้อไวรัส
                    COVID-19 หรือหากมีสถานการณ์เข้าข่ายใน 14
                    วันข้างหน้าท่านจะแจ้งกับทางหน่วยงานจัดซื้อจัดจ้างของบริษัทฯเพื่อรับทราบในทันที*
                  </td>
                  <td className="col-3 text-center">
                    <fieldset id="group7" style={{}}>
                      <label id="lb7" className="containerradio">
                        ใช่ (Yes)
                        <input
                          type="radio"
                          onChange={onRadioChange7}
                          name="group7"
                          id="RadioB7"
                          runat="server"
                          required
                        />
                        <span id="SRadioB7" className="checkmark" />
                      </label>
                      <label
                        className="containerradio"
                        style={{ marginLeft: 5 }}
                      >
                        ไม่ใช่ (No)
                        <input
                          type="radio"
                          name="group7"
                          id="Radio7"
                          runat="server"
                          onChange={onRadioChange77}
                        />
                        <span className="checkmark" />
                      </label>
                    </fieldset>
                  </td>
                </tr>
                <tr data-status={6}>
                  <td style={{ textAlign: "left" }}>
                    8. ท่านรับรองว่าข้อมูลที่ให้เป็นความจริง
                    หากทางบริษัทฯตรวจพบว่าการให้ข้อมูลของท่านเป็นเท็จ
                    ท่านยอมรับถึงบทลงโทษที่ทางบริษัทฯดำเนินมาตรการกับทางท่านและคู่ค้าของบริษัทที่ท่านสังกัด
                  </td>
                  <td className="col-3 text-center">
                    <fieldset id="group8" style={{}}>
                      <label id="lb8" className="containerradio">
                        ใช่ (Yes)
                        <input
                          type="radio"
                          onChange={onRadioChange8}
                          name="group8"
                          id="RadioB8"
                          runat="server"
                          required
                        />
                        <span id="SRadioB8" className="checkmark" />
                      </label>
                      <label
                        className="containerradio"
                        style={{ marginLeft: 5 }}
                      >
                        ไม่ใช่ (No)
                        <input
                          type="radio"
                          name="group8"
                          id="Radio8"
                          runat="server"
                          onChange={onRadioChange88}
                        />
                        <span className="checkmark" />
                      </label>
                    </fieldset>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-end">
            <div className="row col-12 col-xs-6 col-md-4">
              <Button style={{width:120,}} color="primary" type="primary" onClick={handelsave}>
                บันทึก
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormCovid;
